/** Display helpers for ImeiHub stat widgets (counts come from /api/imei/stats). */

export type ImeiHubStatsSnapshot = {
  total_checks: number
  stolen_today: number
  locked_today: number
  financed_today: number
}

export function normalizeImeiHubStats(data: Partial<ImeiHubStatsSnapshot> | null | undefined): ImeiHubStatsSnapshot | null {
  if (!data) return null
  const { total_checks, stolen_today, locked_today, financed_today } = data
  if (
    typeof total_checks !== 'number' ||
    typeof stolen_today !== 'number' ||
    typeof locked_today !== 'number' ||
    typeof financed_today !== 'number'
  ) {
    return null
  }
  return { total_checks, stolen_today, locked_today, financed_today }
}

export function parseImeiChecksDisplayBase(raw: string | undefined | null): number {
  if (raw == null || String(raw).trim() === '') return 0
  const n = Number.parseInt(String(raw).trim(), 10)
  return Number.isFinite(n) && n >= 0 ? n : 0
}

/** @deprecated Use /api/imei/stats — kept for optional env seed parsing only. */
export function resolveImeiChecksDisplay(raw: string | undefined | null): number {
  return parseImeiChecksDisplayBase(raw)
}

/** @deprecated Use /api/imei/stats — kept for optional env seed parsing only. */
export function resolveImeiStolenTodayDisplay(raw: string | undefined | null): number {
  return parseImeiChecksDisplayBase(raw)
}

export function formatImeiHubStatCount(value: number, locale: string): string {
  try {
    return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(value)
  } catch {
    return String(value)
  }
}
